import React from 'react';

export const BetaBadge: React.FC = () => (
  <span className="text-xs bg-purple-700/60 px-1.5 py-0.5 rounded font-medium tracking-wide text-white">
    BETA
  </span>
);
